import React, { useState, useEffect } from "react";
import axios from "axios";
import BulkRegistration from "./BulkRegistration";
import Demographics from "./Demographics";
import EmailEditor from "./EmailEditor";
import AdminDisputesPage from "../dispute/AdminDispute";
import AdminFeedback from "../feedback/AdminFeedback";
import AdminHome from "./AdminHome";
import UnverifiedUsers from "./UnverifiedUsers";
import "./style.css";
import SearchUser from "./SearchUser";
import Users from "./Users";
import RecentTransactions from "./RecentTransactions";
import Subscription from "./Subscription";
import AdminSidebar from "./AdminSidebar";


const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("home");
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [profile, setProfile] = useState(localStorage.getItem("userRole") || "");

  const userToken = localStorage.getItem("userToken");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab");
    const allowedTabs = new Set([
      "bulk",
      "graphs",
      "email",
      "home",
      "feedback",
      "dispute",
      "unverifiedUsers",
      "search",
      "users",
      "recentTransactions",
      "subscription",
    ]);
    if (tab && allowedTabs.has(tab)) {
      setActiveTab(tab);
    }
  }, []);

  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/user`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        const profileType = response?.data?.user?.profileType;
        setProfile(profileType);
        if (profileType) {
          localStorage.setItem("userRole", profileType);
        }
      })
      .catch(() => {});
  }, [userToken]);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "bulk":
        return <BulkRegistration />;
      case "graphs":
        return <Demographics />;
      case "email":
        return <EmailEditor />;
      case "home":
        return <AdminHome />;
      case "feedback":
        return <AdminFeedback />;
      case "dispute":
        return <AdminDisputesPage />;
      case "unverifiedUsers":
        return <UnverifiedUsers />;
      case "search":
        return <SearchUser />
      case "users":
        return <Users />
      case "recentTransactions":
        return <RecentTransactions />
      case "subscription":
        return <Subscription />
      default:
        return <AdminHome />;
    }
  };

  return (
    <>
      <div className="admin-dashboard">
        <button className="menu-toggle" onClick={toggleSidebar}>
          Menu
        </button>

        <AdminSidebar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
          profile={profile}
        />

        <div className="content">{renderContent()}</div>
      </div>
    </>
  );
};

export default AdminDashboard;
